import { render, staticRenderFns } from "./EnvironmentEffectsPopup.vue?vue&type=template&id=7a4476ca&scoped=true"
import script from "./EnvironmentEffectsPopup.vue?vue&type=script&lang=js"
export * from "./EnvironmentEffectsPopup.vue?vue&type=script&lang=js"
import style0 from "./EnvironmentEffectsPopup.vue?vue&type=style&index=0&id=7a4476ca&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7a4476ca",
  null
  
)

export default component.exports